import EmptyRouterView from './../views/administrator/EmptyRouterView.vue'
import BedsHome from './../views/administrator/beds/BedsHome.vue'
import ReportTable from './../views/administrator/ReportTable.vue'
import Users from './../views/administrator/manteiners/UsersMaintainer.vue';
import Home from './../views/administrator/Home.vue';

import BedsManteiner from './../views/administrator/manteiners/BedsManteiner.vue'
export const routes = [
  { path: '/administrador', 
    component: EmptyRouterView,
    children: [
      {
        path:'',
        name:'administratorReport',
        component:ReportTable,
      },
      {
        path:'camas',
        name:'administratorBeds',
        component:BedsHome,
      },
      {
        path:'reporte',
        name:'administratorReport',
        component:ReportTable,
      },
      {
        path:'usuarios',
        name:'administratorUser',
        component:Users,
      },
      {
        path:'mantenedorCamas',
        name:'administratorBedsManteiner',
        component:BedsManteiner,
      },
      {
        path: 'inicio',
        name: 'administratorHome', 
        component: Home,
      },
    ]
  },
]